module.exports = __webpack_public_path__ + "img/20210618_072659.7e214774.jpg";